import React, { ChangeEvent, useEffect, useState } from 'react';
import { Button, Card, Checkbox, DatePicker,  Form, Input, InputNumber, Modal, Radio, Space, Table, Tag } from 'antd';
import type { DatePickerProps, TableColumnsType } from 'antd';
import { CustomAxios } from "../../services/api";
import type { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { FilterValue, SorterResult } from "antd/es/table/interface";
import { ClubInfosType, MemberListType, MessageListType, TableColumnMessageType, TableColumnType, memberListArray, messageListArray } from './common.type';
import {
    BarChartOutlined,
    CaretRightOutlined,
    CheckCircleOutlined,
    DeleteOutlined,
    ExperimentOutlined,
    ImportOutlined,
    LikeOutlined,
    PlusOutlined,
    SearchOutlined,
  } from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
import moment from "moment";

interface MessageListPopUpProps {
    agentSeq?: string;
    clubSeq?: string;
    selectedRecord: any;
    refresh:any;
}

interface TableParams {
    pagination?: TablePaginationConfig;
    sortField?: string;
    sortOrder?: string;
    filters?: Record<string, FilterValue>;
  }


const MessageListPopUp: React.FC<MessageListPopUpProps> = ({ selectedRecord, refresh ,agentSeq ,clubSeq}) => {
  const [loading, setLoading] = useState(false);  
  // 테이블 페이징파라미터 
  const [tableParams, setTableParams] = useState<TableParams>({
      pagination: {
        current: 1,
        pageSize: 3,
      },
    });
  const [total, setTotal] = useState(0);
  const today = moment();
  var date = new Date();
  const [messageAry, setMessageAry] = useState<messageListArray[]>();
  const [columnData, setColumnData] = useState<TableColumnMessageType[]>();
  const [tagAry, setTagAry] = useState<string[]>([]);  
  const timestamp = Date.now();
  const [refresh1, setRefresh1] = useState(timestamp);

  useEffect(() => {   
    console.log("리프레시")
    requestGetMessageList();
    }, [refresh]);

  useEffect(() => {   
    requestGetMessageList();
    }, [JSON.stringify(tableParams)]);
  // 테이블 페이징변경 
  const handleTableChange = (
      pagination: TablePaginationConfig,
      filters: Record<string, FilterValue>,
      sorter: SorterResult<TableColumnMessageType>
    ) => {
      setTableParams({
        pagination,
        filters,
        ...sorter,
      });
    };
  
    // 메시지리스트 가져오기
    const requestGetMessageList = () => {
      console.log("selectedRecord?.memberId  ", selectedRecord?.memberId );
      console.log("clubSeq  ", clubSeq );
      //setLoading(true);
      CustomAxios.getMessageList({
        page: Number(tableParams.pagination?.current) - 1,
        size: Number(tableParams.pagination?.pageSize),
        clubSeq: Number(clubSeq),
        memberId: selectedRecord?.memberId ,
      }).then(
      (response:any) => {
        console.log("1대N  :" + JSON.stringify(response.data,null,2))
          const messageLists: MessageListType = response.data;        
          console.log("messageLists",messageLists);
  
          setTotal(messageLists.totalElements);
          setMessageAry(() => messageLists.content);
          setLoading(false);
          setTableParams({
          ...tableParams,
          pagination: {
              ...tableParams.pagination,
              total: messageLists.totalElements,
          },
          });
      },
      (error:any) => {
      }
      );
  };
  // 테이블 자료구조 
  useEffect(() => {
      const columnData = messageAry?.map((item, i) => ({
        key: i,
        personalMessageSeq: item.personalMessageSeq,
        title: item.title,
        message: item.message,
        filePath : item.filePath,
        updated : item.updated,
        originalFileName : item.originalFileName,
        savedFileName : item.savedFileName,
        fileUrl : item.fileUrl,
        receiverCount : item.receiverCount
      }));
      console.log("전체값 체크 : " + JSON.stringify(columnData,null,2))
      setColumnData(() => columnData);
    }, [messageAry]);   

  // 테이블화면구성 
  const columns: ColumnsType<TableColumnMessageType> = [
  { title: "seq", dataIndex: "personalMessageSeq" },
  { title: "제목", dataIndex: "title" },  
  { title: "메시지", dataIndex: "message" },
  { title: "날짜", dataIndex: "updated" },
  { title: "파일", dataIndex: "originalFileName" ,
  
  key: "y",
  render: (text, record, index) => {
    // recode가 아닌 record를 사용해야 함
    const cleanedFilePath = record.originalFileName.replace(/[\[\]]/g, '');  
    const savedPath = record.savedFileName;
    const cleanedPath = record.filePath.replace(/[\[\]]/g, '');
    const fileUrl=record.fileUrl;
    const linkurl= fileUrl + savedPath.replace(/[\[\]]/g, '').replace(/\⧩✈⧨/g, ',');


    console.log ("새경로  : "+ linkurl)
    console.log("cleanedPath : " + cleanedPath)
    console.log("cleanedFilePath : " + cleanedFilePath)
   
    const fileNames = [];
    const originPaths = cleanedFilePath.split(',');
    const linkPaths = cleanedPath.split(',');
    const savedpaths = savedPath.split(',');


    console.log("fileUrl : " + fileUrl)
    console.log("linkPaths : " + linkPaths)
    console.log("cleanedPath : " + cleanedPath)
   

    for (let i = 0; i < originPaths.length; i++) {
      const path = originPaths[i].trim().replace(/\⧩✈⧨/g, ',');

      console.log("downlod ", linkPaths[i]);
      console.log("최종  : "  + savedpaths[i])

      fileNames.push(
        <Tag key={path} onClick={(e) => part(e, record, fileUrl+savedpaths[i].replace(/\]/g, '').replace(/\[/g, '').replace(/\⧩✈⧨/g, ',').trim())} color="purple" style={{ textAlign: 'center', marginLeft: 0, cursor: 'pointer' }}>
          {path}
        </Tag>
      );
    }

    return (
      <div>{fileNames}</div>
    );
  },
},
{ title: "전송개수", dataIndex: "receiverCount" },
  
  ];

/*
{
    title: "링크",
    dataIndex: "originalFileName",
    key: "x",
    render: (text, record, index) => (
    <Space>           
        <Button onClick={(e) => part(e, record)} icon={<ImportOutlined />}>파일링크</Button>
    </Space>
    ),
},
*/

  const part = (e: any, recode: TableColumnMessageType, path: string) => {
    const parts = path.trim().split('/');
    const fileName = parts[parts.length - 1];
    console.log("최종 url : " + fileName)
    const newWindow = window.open(recode.fileUrl + "" + fileName.replace(/\⧩✈⧨/g, ','), '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
  }
  /*
    const cleanedFilePath = recode.filePath.replace(/[\[\]]/g, '');
    console.log("part", cleanedFilePath);   
    const fileNames = cleanedFilePath.split(',').map(path => {
          const parts = path.trim().split('/');
          return parts[parts.length - 1];
      });

    console.log("fileNames", fileNames);     
    fileNames.forEach(fileName => {

      if (fileName.includes(path)) {
      const newWindow = window.open(recode.fileUrl + "" + fileName, '_blank', 'noopener,noreferrer');
      console.log("fileNames", recode.fileUrl + "" + fileName);     
      if (newWindow) {
          newWindow.opener = null;
      }
    }
   
});
 */
    // const newWindow = window.open(recode.fileUrl + "" + cleanedFilePath, '_blank', 'noopener,noreferrer');
    // if (newWindow) {
    //     newWindow.opener = null;
    // }  
};   

    return (
        <div>
         <Table
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={columnData}
                style={{ width: "100%", height: "100%", marginTop: 0 }}
                pagination={tableParams.pagination}
                loading={loading}
                onChange={(val: any, filter: any, sorter: any, extra: any) => {
                  handleTableChange(val, filter, sorter);
                }}
              />
        </div>
    );
}

export default MessageListPopUp;